<mat-icon class="arrow" *ngIf="canShowArrow()" [style.top.px]="arrowPosition.y" [style.left.px]="arrowPosition.x" svgIcon="atoms-arrow"></mat-icon>

<section #matCardElement fxLayout="column">
  <vdw-header [title]="'PRODUCTION_ORDER.WEAVE_PLAN.EDIT_DESIGN_IN_PATH_GROUP.EDIT_DESIGN' | bmsTranslate" [canShowClose]="true"></vdw-header>
  <article class="dialog-content">
    <div [formGroup]="productionScheduleItemInPathGroupForm" fxLayout="column">
      <div fxLayout="column">
        <div fxLayout="row" fxLayoutGap="16px">
          <mat-form-field fxFlex>
            <mat-label>{{ 'DESIGN_LIBRARY.DETAILS.DESIGN_NAME' | bmsTranslate }}</mat-label>
            <input matInput type="text" formControlName="name" appDataCy="design-name" />
          </mat-form-field>

          <mat-form-field fxFlex *ngIf="canShowCode()">
            <mat-label>{{ 'DESIGN_LIBRARY.DETAILS.DESIGN_CODE' | bmsTranslate }}</mat-label>
            <input matInput type="text" formControlName="code" />
          </mat-form-field>
        </div>

        <div class="flex-row gap-16">
          <mat-form-field fxFlex *ngIf="completingPartially">
            <mat-label>{{ 'GENERAL.PIECES' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" formControlName="amountProduced" />
            <mat-error *ngIf="canShowErrorForFormControl('amountProduced', 'required')">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex *ngIf="!completingPartially">
            <mat-label>{{ 'GENERAL.PIECES' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" min="1" formControlName="quantity" />
            <mat-hint *ngIf="hasOrderLine()">
              {{ 'PRODUCTION_ORDER.WEAVE_PLAN.EDIT_DESIGN_IN_PATH_GROUP.QUANTITY_HINT' | bmsTranslate: {quantityLeft: quantityLeft, total: getMaximumValueForQuantity()} }}
            </mat-hint>
            <mat-error *ngIf="canShowErrorForFormControl('quantity', 'required')">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
            <mat-error *ngIf="canShowErrorForFormControl('quantity', 'min')">
              {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: '1'} }}
            </mat-error>
            <mat-error *ngIf="canShowErrorForFormControl('quantity', 'max')">
              {{ 'GENERAL.ERRORS.MAX_VALUE' | bmsTranslate: {max: getMaximumValueForQuantity()} }}
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>{{ 'GENERAL.REPEATS' | bmsTranslate }}</mat-label>
            <input matInput disabled [value]="getAmountOfCarpetsBasedOnQuantity()" />
          </mat-form-field>
        </div>
      </div>

      <h4 class="font-weight-regular" *ngIf="canShowCommercialDimensions() || canShowTechnicalDimensions()">{{ 'GENERAL.DIMENSIONS.DIMENSIONS' | bmsTranslate }}</h4>

      <div fxLayout="column">
        <div fxLayout="row" fxLayoutGap="16px" *ngIf="canShowCommercialDimensions()">
          <mat-form-field fxFlex>
            <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" step="0.01" formControlName="commercialHeight" [decimals]="true" />
            <span matSuffix>{{ commercialUnit }}</span>
            <mat-error *vdwCanShowErrorForFormControl="'commercialHeight'; error: 'badInput'">
              {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
            </mat-error>
            <mat-error *ngIf="canShowErrorForFormControl('commercialHeight', 'required')">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
            <mat-error *ngIf="canShowErrorForFormControl('commercialHeight', 'min')">
              {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: '1'} }}
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>{{ 'GENERAL.DIMENSIONS.WIDTH' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" step="0.01" formControlName="commercialWidth" [decimals]="true" />
            <span matSuffix>{{ commercialUnit }}</span>
            <mat-error *vdwCanShowErrorForFormControl="'commercialWidth'; error: 'badInput'">
              {{ 'GENERAL.ERRORS.INVALID_FORMAT.INVALID_FORMAT' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="row" *ngIf="canShowTechnicalDimensions()" fxLayoutGap="16px">
          <mat-form-field fxFlex>
            <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" formControlName="technicalHeight" />
            <span matSuffix>{{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}</span>
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>{{ 'GENERAL.DIMENSIONS.WIDTH' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" formControlName="technicalWidth" />
            <span matSuffix>{{ 'GENERAL.UNIT.DENTS' | bmsTranslate }}</span>
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="canShowFinishingField()" class="flex-row gap-16">
        <mat-form-field class="full-width">
          <mat-label>
            {{ 'TEXTILE_DATA.FINISHING.FINISHING' | bmsTranslate: {count: 1} }}<span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
          </mat-label>
          <vdw-object-selection
            formControlName="finishing"
            [objectName]="'TEXTILE_DATA.FINISHING.FINISHING' | bmsTranslate: {count: 1} | lowercase"
            [chipValueKey]="FINISHING_CHIP_VALUE_KEY"
            [baseRouterLink]="FINISHING_BASE_ROUTER_LINK"
            (selectClicked)="changeCurrentFinishing()"
          ></vdw-object-selection>
          <mat-hint>{{ noPermissionsToSelectFinishingHint() }}</mat-hint>
        </mat-form-field>
        <div *ngIf="hasChosenFinishing()" fxFlex fxLayoutAlign="left center" class="info-balloon-container">
          <mat-icon class="finishing-info" svgIcon="info" (click)="showFinishingDetails($event)"></mat-icon>
        </div>
      </div>

      <div fxLayout="column" *ngIf="canShowCutbarsFields()">
        <h4 class="font-weight-regular">{{ 'TEXTILE_DATA.FINISHING.CUTBAR.CUTBAR' | bmsTranslate: {count: 2} }}</h4>
        <div fxLayout="row">
          <mat-form-field>
            <mat-label>{{ 'PRODUCTION_ORDER.WEAVE_PLAN.EDIT_DESIGN_IN_PATH_GROUP.BEFORE' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" min="1" formControlName="cutbarBeforeCommercialLength" />
            <span matSuffix>{{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}</span>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'PRODUCTION_ORDER.WEAVE_PLAN.EDIT_DESIGN_IN_PATH_GROUP.AFTER' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" min="1" formControlName="cutbarAfterCommercialLength" />
            <span matSuffix>{{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}</span>
          </mat-form-field>
        </div>
      </div>
    </div>
  </article>

  <vdw-footer
    [locked]="!canEditProductionScheduleItemInPathGroup()"
    cancelEventName="GENERAL.ACTIONS.DELETE"
    chooseEventName="GENERAL.ACTIONS.EDIT"
    [centered]="true"
    (cancelEvent)="cancelEvent()"
    (chooseEvent)="applyChangesToProductionScheduleItemInPathGroup()"
  ></vdw-footer>
</section>
